export const AND_CONDITION = 'AND';
export const OR_CONDITION = 'OR';
